<div #selectItem class="select-wrapper" style='--columns:{{labelWidth}} {{dropdownWidth}}'>
    <p class="select__label-text {{labelCssClasses}}"
       [ngClass]="{'disable-label': disabled}">
        {{labelText}}
    </p>
    <app-select-menu-no-label
            [requiredField]="requiredField"
            [showDeselectedOptions]="showDeselectedOptions"
            [placeholder]="placeholder"
            [tabIndex]="tabIndex"
            [options]="options"
            [dropdownHeight]="dropdownHeight"
            [labelClasses]="labelClasses"
            [fontSizeClasses]="fontSizeClasses"
            [disabled]="disabled"
            [ariaLabel]="ariaLabel"
            [selectedId]="selectedId"
            [formFieldControl]="formFieldControl"
            [formFieldGroup]="formFieldGroup"
            (valueChangeEvent)="valueChanged($event)"
            (keyUpChangeEvent)="onKeyUp($event)">
    </app-select-menu-no-label>
</div>